/* Monzalo: cart discount progress start */
(function () {
  'use strict';
  function progressState(quantity) {
    const count = Math.max(0, Number(quantity) || 0);
    return {
      hidden: count === 0,
      percent: Math.min(count, 3) * 100 / 3,
      first: count >= 2,
      second: count >= 3,
      message: count >= 3 ? '15% extra off unlocked!' : count >= 2
        ? '10% extra off unlocked. Add 1 more item for 15%.' : count === 1
          ? 'Add 1 more item to unlock 10% extra off.' : 'Add 2 items to unlock 10% extra off.'
    };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {progressState};
  if (typeof customElements === 'undefined' || customElements.get('monzalo-cart-progress')) return;
  customElements.define('monzalo-cart-progress', class extends HTMLElement {
    connectedCallback() {
      this.onCartUpdate = () => {
        const cart = this.closest('cart-element');
        if (!cart) return;
        const quantity = Array.from(cart.querySelectorAll('[data-items-holder] [data-quantity-field]'))
          .reduce((total, input) => total + (Number(input.value) || 0), 0);
        this.render(quantity);
      };
      this.render(Number(this.dataset.count));
      document.addEventListener('theme:cart:added', this.onCartUpdate);
      document.addEventListener('theme:cart:loaded', this.onCartUpdate);
    }
    disconnectedCallback() {
      document.removeEventListener('theme:cart:added', this.onCartUpdate);
      document.removeEventListener('theme:cart:loaded', this.onCartUpdate);
    }
    render(quantity) {
      const state = progressState(quantity);
      this.hidden = state.hidden;
      this.dataset.count = String(quantity);
      const message = this.querySelector('[data-discount-message]');
      if (message.textContent !== state.message) message.textContent = state.message;
      const bar = this.querySelector('[data-discount-bar]');
      bar.style.setProperty('--monzalo-progress', `${state.percent}%`);
      bar.setAttribute('aria-valuenow', Math.min(quantity, 3));
      bar.setAttribute('aria-valuetext', state.message);
      this.querySelector('[data-tier="2"]').classList.toggle('is-unlocked', state.first);
      this.querySelector('[data-tier="3"]').classList.toggle('is-unlocked', state.second);
    }
  });
})();
/* Monzalo: cart discount progress end */
